import React from "react"
import styled from "styled-components"
import Logo from '../../svgs/logo.svg'
import Menu from './menu'

const Container = styled.header`
  position: absolute;
  z-index:1 ;
  background-color: transparent;
  width: 100%;
  margin-top: 15px;
  

  &.show {
    @media (max-width: 796px) {
      position: fixed;
      margin-top: 0;
      padding-top: 15px;
      max-width: 100vw;
      height: 100%;
    }
  }
`
const Content = styled.div`
  display: flex;
  justify-content: space-between;
  padding-top: 20px;
  align-items: center;
  @media(min-width: 797px){
    padding-top: initial;
  }

  .mb-menu {
    display: initial;
    @media(min-width: 797px){
      display: none;
  }
  i {
    color: #FFF;
    font-size: 24px;
    cursor: pointer;
  }
  }
`
const Header = ({handle, handleMenu, classTmp}) => (
 <Container className={classTmp}>
   <Content className="container">
    <a href="/"><Logo /></a>
    <div className="mb-menu">
    <i className="far fa-bars" onClick={handleMenu} />
      {/* {classTmp === 'show' ? 
      
      : 
      
      } */}
     
    </div>
    <Menu classTmp={classTmp} handle={handle} handleMenu={handleMenu} />
   </Content>
 </Container>
)
export default Header
